import { render, staticRenderFns } from "./SaveCommonCertificate.vue?vue&type=template&id=5400b533&scoped=true"
import script from "./SaveCommonCertificate.vue?vue&type=script&lang=js"
export * from "./SaveCommonCertificate.vue?vue&type=script&lang=js"
import style0 from "./SaveCommonCertificate.vue?vue&type=style&index=0&id=5400b533&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5400b533",
  null
  
)

export default component.exports